import { fillString } from '@local_modules/generic/string-template.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'

import { checkPageRestriction } from '../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../helpers/restrictions/apply-html-restrictions.js'

import htmlTemplateIndex from './index.html'
import { showTableTrackings } from './show-table.js'

/**
 *
 * @returns
 */
export async function showPageTrackingsPG (params) {
  console.log('showPageTrackingsPG')

  const { containerElementId, browserAppUser, browserAppAccount } = params

  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.title = ['Group Trackings:', browserAppAccount.data.appAccount.name].join(' ')

  // Set full height
  document.getElementById(containerElementId)?.classList.add('position-absolute')
  document.getElementById(containerElementId)?.classList.add('top-to-bottom')

  showTableTrackings(browserAppAccount)
}
